import React, { Component } from 'react';
import { Container, Row, Col, Label, Input, Button, Fade } from 'reactstrap';
import { getSharedRecord, downloadSharedRecord } from '../services';
import { pregnancyColumns, childColumns, medicalColumns, thyroidColumns, downloadColumns, concieveColumns, subtypeColums, documentTypeColumns, bloodSugarColumns, bloodPressureColumns } from './Columns';
import queryString from 'query-string';
import ShareTable from './ShareTable';
import { downloadFile } from '../../utils';

class ViewSharedRecord extends Component {

  state = {
    password: '',
    token: '',
    model: '',
    records: [],
    message: '',
    success: true
  }

  componentDidMount() {
    const { token } = this.props.match.params;
    const model = queryString.parse(this.props.location.search);
    this.setState(prevState => ({
      token,
      model,
    }))
  }

  handlePassword = (event) => {
    const value = event.target.value;
    this.setState(prevState => ({
      password: value
    }))
  }

  handleSubmit = async () => {
    const { password, token } = this.state;

    let data = {
      password,
      token
    }
    const response = await getSharedRecord(data);
    this.setState(prevState => ({
      records: response.data.result,
      message: response.data.message,
      success: false
    }))
  }

  handleDownload = async (recordId) => {
    const { password, token } = this.state;
    let data = {
      token,
      password,
      recordId
    }

    const response = await downloadSharedRecord(data);
    downloadFile(response.data, "record");
  }

  renderTable = () => {
    const { records, model, message } = this.state;
    const recordType = model.t;

    const downloadColumns = [
      {
        dataField: "download",
        text: "Download",
        isDummyField: true,
        formatter: (cell, row, rowIndex) => <span className="fa fa-download"></span>,
        align: "center",
        events: {
          onClick: (e, column, columnIndex, row) => this.handleDownload(row._id)
        }
      }
    ]
    let columns;
    if(recordType == 0) {
      if(records[0].pregnancyType == 1) {
        columns = [...pregnancyColumns, ...concieveColumns, ...downloadColumns]
      } else if(records[0].pregnancyType == 2) {
        columns = [...pregnancyColumns, ...documentTypeColumns, ...downloadColumns]
      } else if(records[0].pregnancyType == 3) {
        columns = [...pregnancyColumns, ...subtypeColums, ...downloadColumns]
      }
      console.log(columns);
      return <ShareTable data={records} columns={columns} message={message}/>
    } else if(recordType == 1) {
      columns = [...childColumns, ...downloadColumns]
      return <ShareTable data={records} columns={childColumns} message={message}/>
    } else if(recordType == 2) {
      columns = [...medicalColumns, ...downloadColumns]
      return <ShareTable data={records} columns={columns} message={message}/>
    } else if(recordType == 3) {
      return <ShareTable data={records} columns={thyroidColumns} message={message}/>
    } else if(recordType == 4) {
      columns = [...bloodSugarColumns, ...downloadColumns]
      return <ShareTable data={records} columns={columns} message={message}/>
    } else if(recordType == 5) {
      columns = [...bloodPressureColumns, ...downloadColumns]
      return <ShareTable data={records} columns={columns} message={message}/>
    }
  }
 
  render() {

    const { success, records } = this.state;

    return (
      <Container>
        <Fade in={success}>
          <Row className="d-flex flex-column justify-content-center align-items-center">
            <Col xs="5">
              <Label>Enter your password</Label>
              <Input type="password" onChange={this.handlePassword}/>
              <Button onClick={this.handleSubmit}>Submit</Button>
            </Col>
          </Row>
        </Fade>
        {records.length > 0 && 
          this.renderTable()
        }
      </Container>
    )
  }
}

export default ViewSharedRecord;


// WEBPACK FOOTER //
// ./src/views/PersonalHealthRecord/ViewSharedRecord.js